import React from 'react';
import { motion } from 'framer-motion';

const techs = ['React', 'Node.js', 'AI Systems', 'WebSocket / Real-Time', 'Cloud Infrastructure', 'ESP32 / Embedded'];

const TechStack = () => {
  return (
    <section id="tech" className="py-20 px-6 bg-gray-800 text-gray-100">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto text-center mb-12"
      >
        <h2 className="text-3xl font-bold">Technology Stack</h2>
      </motion.div>
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-6">
        {techs.map((t, i) => (
          <motion.div
            key={i}
            whileHover={{ scale: 1.05 }}
            className="px-4 py-2 bg-gray-900 rounded-full text-sm font-medium glow"
          >
            {t}
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default TechStack;
